export const INVOICE_QR_FLAG = 'invoice-qr-logos';

/**
 * Gates the "Modo testing" toggle: when on, the user may route stamping to the sandbox
 * endpoint (cfdi-testing) instead of the real cfdi-4.0 one. In the v2 flow, sandbox is
 * the default for flag holders and everyone else always stamps for real.
 */
export const INVOICE_TESTING_FLAG = 'invoice-allow-test-endpoint';

/**
 * Fue el canario del motor de timbrado de la facturación nueva: decidía si una
 * emisión la resolvía `heru-fiscal-engine` (Go) o `heru-core-invoice-service`
 * (NestJS). Ya no la lee nadie en la web: la facturación nueva timbra todo en
 * el Go, el complemento de pago incluido, y `/invoice` nunca la consultó.
 *
 * Se conserva la clave por decisión de producto mientras se apaga el NestJS.
 * ⚠️ No se renombra: el tracking key del experimento en GrowthBook es igual al
 * feature key, y los `experiment_viewed` que ya están en Amplitude cruzan con
 * lo que persistió el backend por ese nombre.
 */
export const INVOICE_GO_ENGINE_FLAG = 'invoice-go-engine';

/**
 * Interruptor del motor del mostrador de facturación por QR.
 *
 * Es una feature booleana simple: sin experimento, sin variaciones, sin
 * bucketing y sin exposición que registrar. No podría ser otra cosa: la página
 * del mostrador es ANÓNIMA, ahí no existe `user_id` y GrowthBook solo conocería
 * el `anonymous_id`, así que cualquier diseño que dependa de bucketear al
 * usuario se rompe en la mitad del flujo. Un valor plano sí funciona.
 */
export const INVOICE_QR_GO_ENGINE_FLAG = 'invoice-qr-go-engine';

/**
 * Modo mantenimiento del QR, para migrar o desplegar sin que entre nada nuevo.
 * Booleana, apagada por default. Encendida, la página pública (legacy y nueva)
 * y la del dueño muestran una pantalla de mantenimiento, y las entradas del
 * dueño desaparecen sin disparar ninguna llamada del QR: el GET de la config
 * CREA la página si no existe, en los dos motores.
 *
 * Se prende con una regla sin condiciones, nunca por usuario: quien abre la
 * página pública es anónimo y no trae `user_id`. Si GrowthBook no responde, se
 * sirve lo normal. No toca `invoice-qr-logos`.
 */
export const INVOICE_QR_MAINTENANCE_FLAG = 'invoice-qr-maintenance';

/**
 * Asistente de IA del flujo nuevo de facturación (beta, POC). Booleana simple,
 * apagada por default: sin bandera no se pinta ni el botón ni el panel.
 */
export const INVOICE_AI_ASSISTANT_FLAG = 'invoice-ai-assistant';

/**
 * Invoicing charged by quota: the exhausted-quota paywall when entering the wizard,
 * the plan chip of the home and the invoicing plans screen. A plain boolean, off by
 * default: without it `GET /cfdi/cupo` is never called and invoicing looks as today.
 *
 * Only turned on with `CFDI_QUOTA_MODE=enforce` in the fiscal-engine. In `shadow`
 * the server counts but does not block, and the web would be stopping someone who
 * could actually stamp.
 */
export const INVOICE_QUOTA_FLAG = 'invoice-quota-plans';

/**
 * La marca propia en el PDF de las facturas que emite el usuario (`/facturacion/marca`).
 * Booleana por usuario, apagada por default. Es un AND con la allowlist del backend
 * (`SERVICE_PDF_BRANDING_USERS` del fiscal-engine): con la bandera y sin la allowlist,
 * `GET /cfdi/pdf-brand` responde 404 y la pantalla y su entrada no aparecen.
 */
export const INVOICE_PDF_BRANDING_FLAG = 'invoice-pdf-branding';
